import { Injectable } from '@angular/core';
import { GiftCardsGatewayService } from './gift-cards-gateway.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Category } from 'src/app/shared/models/category.model';
import { PhysicalOrderList } from '../models/physical-order-list.model';
import { User } from 'src/app/shared/models/user.model';
import { ReportParams } from '../models/report-params.model';
import { PhysicalCardStatus } from '../models/card-status.model';
import { PhysicalActivate } from '../models/physical-cards.model';

interface QueryParams {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})

export class GiftCardsFacadeService {

  public basket  = new BehaviorSubject<Array<any>>([])

  constructor(private giftCardsGatewayService: GiftCardsGatewayService) { }

  getCategories(accessory): Observable<Category[]> {
    return this.giftCardsGatewayService.getCategories(accessory);
  }

  getCategoriesForPhysical(filters):Observable<Category[]>{
    return this.giftCardsGatewayService.getCategoriesForPhysical(filters);
  }

  getProductList(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<any> {
    return this.giftCardsGatewayService.getProductList(limit, offset, query_params)
  }

  getAccessoryProducts(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<any> {
    return this.giftCardsGatewayService.getAccessoriesProducts(limit, offset, query_params)
  }

  getAccessoryOrdersList(filters): Observable<any> {
    return this.giftCardsGatewayService.getAccessoryOrdersList(filters);
  }

  getAccessoryOrderDetail(filters): Observable<any> {
    return this.giftCardsGatewayService.getAccessoryOrderDetail(filters);
  }

  createAccessoryOrder(data): Observable<any> {
    return this.giftCardsGatewayService.createAccessoryOrder(data)
  }

  getPhysicalOrdersList(filters?): Observable<PhysicalOrderList> {
    return this.giftCardsGatewayService.getPhysicalOrdersList(filters);
  }
  
  getPhysicalOrdersArchiveList(filters?): Observable<PhysicalOrderList> {
    return this.giftCardsGatewayService.getPhysicalOrdersArchiveList(filters);
  }

  getUserDetail(userId: number): Observable<User> {
    return this.giftCardsGatewayService.getUserDetail(userId);
  }

  getReport(reportParams: ReportParams): Observable<any> {
    return this.giftCardsGatewayService.getReport(reportParams);
  }

  getProductDetail(productId: number): Observable<any> {
    return this.giftCardsGatewayService.getProductDetail(productId);
  }

  getUserReport(reportItems: ReportParams): Observable<any> {
    return this.giftCardsGatewayService.getUserReport(reportItems);
  }

  getOrders(limit: number, offset: number, filters?: any): Observable<any> {
    return this.giftCardsGatewayService.getOrders(limit, offset, filters);
  }

  getGiftCardStatus(serialNumber: number): Observable<PhysicalCardStatus> {
    return this.giftCardsGatewayService.getGiftCardStatus(serialNumber);
  }

  activateGiftCard(serialNumber: number, price: number, pin?: number): Observable<PhysicalActivate> {
    return this.giftCardsGatewayService.activateGiftCard(serialNumber, price, pin)
  }

  activateBulkGiftCard(data): Observable<PhysicalActivate> {
    return this.giftCardsGatewayService.activateBulkGiftCard(data);
  }

  getSubscriptionOrderList(filters?): Observable<any> {
    return this.giftCardsGatewayService.getSubscriptionOrderList(filters);
  }

  createSubscriptionOrder(data): Observable<any> {
    return this.giftCardsGatewayService.createSubscriptionOrder(data);
  }

  getSubscriptionCardList():Observable<any> {
    return this.giftCardsGatewayService.getSubscriptionCardList();
  }

  getSubscriptionCustomerCard(filters?): Observable<any> {
    return this.giftCardsGatewayService.getSubscriptionCustomerCards(filters)
  }

  getSubscriptionGatewayCustomerCard(id, filters?): Observable<any> {
    return this.giftCardsGatewayService.getSubscriptionGatewayCustomerCard(id, filters)
  }

  getSubscriptionGateways(filters?): Observable<any> {
    return this.giftCardsGatewayService.getSubscriptionGateways(filters);
  }

  getSubscriptionPayments(filters?): Observable<any> {
    return this.giftCardsGatewayService.getSubscriptionPayments(filters);
  }

  cancelSubscriptionOrder(id): Observable<any> {
    return this.giftCardsGatewayService.cancelSubscriptionOrder(id);
  }

  validateSubscriptionPayment(data): Observable<any> {
    return this.giftCardsGatewayService.validateSubscriptionPayment(data);
  }

  validateAccessoryOrderPayment(data): Observable<any> {
    return this.giftCardsGatewayService.validateAccessoryOrderPayment(data);
  }

  getBasket():Observable<any[]>{
    return this.basket.asObservable();
  }

  setBasket(item){
    this.basket.next(item)
  }

}
